import React from "react";
import "../styles/ImageBanner.css";
import DonationForm from "./DonationForm";
import { Button } from "react-bootstrap";
import { FaLongArrowAltDown } from "react-icons/fa";

export default function ImageBanner({
  openDonationModal,
  setStartOnContact,
  setDonationAmount,
  donationAmount,
  setDedicatedTo,
}) {
  const goToImpact = () => {
    const el = document.getElementById("impact");
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.hash = "impact";
    }
  };

  return (
    <section className="image-banner image-banner--stjude image-banner--hug-left">
      {/* LEFT: large photo */}
      <div className="left-image">
        <img
          src="img/wheelchair.jpg"
          alt="Gail Thompson Foundation"
          className="left-image__img"
        />
        <span className="subtext">
          Gail "Tee" Thompson and her son Adam sharing a special moment
        </span>
      </div>

      {/* RIGHT: headline + centered donation card */}
      <div className="right-content">
        <header className="intro">
          <h1 className="intro-title">
            Help Bowdoin Baseball Hit Alzheimer's Out Of The Park!
          </h1>
          <p className="intro-sub">
            Every dollar you give supports the Bowdoin Baseball team as we rally
            toward our fundraising goal and more importantly, it brings
            comfort and resources to families with loved ones facing Alzheimer’s
            in a senior care home right here in Brunswick, ME.
          </p>

          {/* CTA to Impact section */}
          <div className="intro-actions">
            <Button
              size="lg"
              variant="outline-brand"
              className="btn-brand-base"
              onClick={goToImpact}
              aria-label="Click to learn where the money is going"
            >
              Click to Learn Where the Money Is Going <FaLongArrowAltDown />
            </Button>
          </div>
        </header>

        <div className="donate-center pt-3">
          <DonationForm
            setDonationAmount={setDonationAmount}
            donationAmount={donationAmount}
            setDedicatedTo={setDedicatedTo}
            onProceedToContact={() => {
              setStartOnContact?.(true);
              openDonationModal?.();
            }}
          />
          <span className="payment-note">
            We accept Card (Visa, Mastercard, Amex), Apple Pay, Google Pay, Amazon Pay, and CashApp
          </span>
        </div>
      </div>
    </section>
  );
}
